import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { BiLinkExternal } from "react-icons/bi";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import MessageSubHeading from "../../../../components/CommonComponents/MessageSubHeading";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";
import AdminCustomSelect from "../../../../components/CommonComponents/AdminCustomSelect";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import AdminCustomButton from "../../../../components/CommonComponents/AdminCustomButton";
import RightWrapper from "../../../../components/CommonComponents/RightWrapper";
import Defaultloadinggif from "../../../../layout/Others/Defaultloadinggif";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import DeviceSelector from "../../../../components/PaymentComponents/DeviceSelector";
import "./PayHere.css";

function Ideabiz(props) {

  const { fetchRequest } = useMyContext()
  const [formData, setFormData] = useState({})
  const [formDataError, setFormDataError] = useState({})
  const [loading, setLoading] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);

  // Supported devices from backend helper
  const [supportedDevices, setSupportedDevices] = useState(['web', 'Android', 'iOS', 'TV']);

  const combinedRef = useRef({});

  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
    }
    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (value == 1) {
        setFormDataError((prev) => ({
          ...prev,
          test_consumer_key: "",
          test_consumer_secret: "",
          test_username: "",
          test_password: ""
        }));
      }
      if (value == 0)
        setFormDataError((prev) => ({
          ...prev,
          live_consumer_key: "",
          live_consumer_secret: "",
          live_username: "",
          live_password: ""
        }));
    }
  };

  const handleDeviceChange = (updatedDevices) => {
    // Filter only valid devices and ensure it's an array
    const validDevices = Array.isArray(updatedDevices)
      ? updatedDevices.filter(device => supportedDevices.includes(device))
      : [];

    console.log('Ideabiz Device change:', { updatedDevices, validDevices, supportedDevices });

    setFormData((prev) => ({
      ...prev,
      supported_devices: validDevices
    }));
  };

  const formValidation = () => {
    let formIsValid = true;
    setFormDataError({}); // Clear previous errors

    // Validate supported devices
    if (!formData?.supported_devices || !Array.isArray(formData.supported_devices) || formData.supported_devices.length === 0) {
      toast.warning('Please select at least one supported device.');
      formIsValid = false;
    }

    if (formData?.payment_mode == 0) {
      if (!formData?.test_consumer_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          test_consumer_key: "Test Consumer Key cannot be empty.",
        }));
        formIsValid = false;
      }
      if (!formData?.test_consumer_secret) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          test_consumer_secret: "Test Consumer Secret cannot be empty.",
        }));
        formIsValid = false;
      }
      if (!formData?.test_username) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          test_username: "Test Username cannot be empty.",
        }));
        formIsValid = false;
      }
      if (!formData?.test_password) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          test_password: "Test Password cannot be empty.",
        }));
        formIsValid = false;
      }
    }
    if (formData?.payment_mode == 1) {
      if (!formData?.live_consumer_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          live_consumer_key: "Live Consumer Key cannot be empty.",
        }));
        formIsValid = false;
      }
      if (!formData?.live_consumer_secret) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          live_consumer_secret: "Live Consumer Secret cannot be empty.",
        }));
        formIsValid = false;
      }
      if (!formData?.live_username) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          live_username: "Live Username cannot be empty.",
        }));
        formIsValid = false;
      }
      if (!formData?.live_password) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          live_password: "Live Password cannot be empty.",
        }));
        formIsValid = false;
      }
    }
    return formIsValid;
  }

  const handleStore = async () => {
    console.log('Ideabiz Form data before validation:', formData);
    if (formValidation()) {
      setLoading(true)
      const dataToSend = {
        ...formData,
        supported_devices: JSON.stringify(formData.supported_devices || [])
      };
      console.log('Ideabiz Data being sent:', dataToSend);

      await fetchRequest({
        method: 'POST',
        url: `${process.env.REACT_APP_Baseurl}/admin/ideabiz_payment/store`,
        params: {},
        data: dataToSend,
      })
        .then(response => {
          if (response?.status) {
            toast.success(response?.message)
            setWithOutRefresh((prev) => !prev)
          }
        }).catch((error => {
          toast.error(error?.response?.data?.message)
        })).finally(() => {
          setLoading(false)
        })
    }
  }

  useEffect(async () => {
    setShowOverlay(true)

    // Fetch supported devices from backend
    try {
      const deviceResponse = await fetchRequest({
        method: 'GET',
        url: `${process.env.REACT_APP_Baseurl}/admin/supported-devices`,
        params: {},
        data: {},
      });

      if (deviceResponse?.status && deviceResponse?.data) {
        setSupportedDevices(deviceResponse.data);
      }
    } catch (error) {
      console.warn('Using default supported devices:', error);
    }

    await fetchRequest({
      method: 'GET',
      url: `${process.env.REACT_APP_Baseurl}/admin/ideabiz_payment/index`,
      params: {},
      data: {},
    })
      .then(response => {
        if (response?.status) {
          const ideabizData = response?.ideabiz_payment;
          let deviceArray = []; // default

          // Parse supported_devices if it exists
          if (ideabizData?.supported_devices) {
            try {
              const parsedDevices = typeof ideabizData.supported_devices === 'string'
                ? JSON.parse(ideabizData.supported_devices)
                : ideabizData.supported_devices;
              deviceArray = Array.isArray(parsedDevices) ? parsedDevices : [];
              console.log('Ideabiz Loaded devices:', deviceArray);
            } catch (error) {
              console.warn('Invalid supported_devices format:', ideabizData.supported_devices);
              deviceArray = [];
            }
          }

          setFormData((prev) => ({
            ...prev,
            ...ideabizData,
            supported_devices: deviceArray
          }));
        }
      }).catch((error => {
        toast.error(error?.response?.data?.message)
      })).finally(() => {
        setShowOverlay(false)
      })
  }, [withOutRefresh]);

  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminBackNavigation id="playout-backbtn" path="/payment_settings" text="Back" />
      <AdminSaveHeader heading={"Ideabiz Payment"} saveText={"Update Ideabiz"} saveMethod={handleStore} loading={loading} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="Ideabiz Configuration" />
            <Link to="https://www.ideabiz.lk/" target="_blank" className="d-inline-flex  align-items-center gap-2 p-2 rounded-2 shadow mb-4">
              <MessageSubHeading text="https://www.ideabiz.lk/" noMargin />
              <BiLinkExternal className="text-dark ms-2" />
            </Link>

            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-7 col-md-7 pe-2">
                <MessageLabel text={"Enable Payment Mode"} />
              </div>
              <div className="col-3 col-md-3 ps-2 text-end">
                <AdminCustomSelect id="ideabizPaymentMode" className="payment-mode-custom-select " name="payment_mode" value={formData?.payment_mode} onChange={handleInput} ref={(el) => (combinedRef.current.payment_mode = el)} options={[{ name: "SANDBOX", value: 0 }, { name: "LIVE", value: 1 }]} error={""} defaultOptionName={""} />
              </div>
            </div>

            <MessageLabel text={"Ideabiz Label"} className="" />
            <AdminCustomInput id="ideabizLabel" type="text" name="ideabiz_label" value={formData?.ideabiz_label} onChange={handleInput} placeHolder={"Ideabiz Label"} ref={(el) => (combinedRef.current.ideabiz_label = el)} error={formDataError?.ideabiz_label} />

            <MessageLabel text={"Currency"} className="" />
            <AdminCustomSelect id="ideabizCurrency" className="currency-custom-select" name="currency" value={formData?.currency || 'LKR'} onChange={handleInput} ref={(el) => (combinedRef.current.currency = el)} options={[{ name: "LKR", value: "LKR" }, { name: "USD", value: "USD" }, { name: "EUR", value: "EUR" }]} error={formDataError?.currency} defaultOptionName={""} />
          </Wrapper>

          <Wrapper>
            <DeviceSelector
              selectedDevices={formData?.supported_devices || []}
              onDeviceChange={handleDeviceChange}
              gatewayName="ideabiz"
              availableDevices={supportedDevices}
              showDescriptions={true}
              label="Supported Devices"
              showSelectAll={true}
              className=""
              cardStyle="default"
              showDeviceStats={true}
            />
          </Wrapper>
        </LeftWrapper>

        <RightWrapper>
          <Wrapper>
            <MessageHeading text="Ideabiz Merchant Details (SANDBOX)" />
            <MessageLabel text={"Test Consumer Key"} className="" />
            <AdminCustomInput id="ideabizTestConsumerKey" type="text" name="test_consumer_key" value={formData?.test_consumer_key} onChange={handleInput} placeHolder={"Test Consumer Key"} ref={(el) => (combinedRef.current.test_consumer_key = el)} error={formDataError?.test_consumer_key} />
            <MessageLabel text={"Test Consumer Secret"} className="" />
            <AdminCustomInput id="ideabizTestConsumerSecret" type="text" name="test_consumer_secret" value={formData?.test_consumer_secret} onChange={handleInput} placeHolder={"Test Consumer Secret"} ref={(el) => (combinedRef.current.test_consumer_secret = el)} error={formDataError?.test_consumer_secret} />
            <MessageLabel text={"Test Username"} className="" />
            <AdminCustomInput id="ideabizTestUsername" type="text" name="test_username" value={formData?.test_username} onChange={handleInput} placeHolder={"Test Username"} ref={(el) => (combinedRef.current.test_username = el)} error={formDataError?.test_username} />
            <MessageLabel text={"Test Password"} className="" />
            <AdminCustomInput id="ideabizTestPassword" type="text" name="test_password" value={formData?.test_password} onChange={handleInput} placeHolder={"Test Password"} ref={(el) => (combinedRef.current.test_password = el)} error={formDataError?.test_password} />
            <MessageLabel text={"Test Auth Token"} className="" />
            <AdminCustomInput id="ideabizTestAuthToken" type="text" name="test_auth_token" value={formData?.test_auth_token} onChange={handleInput} placeHolder={"Test Auth Token (Optional)"} ref={(el) => (combinedRef.current.test_auth_token = el)} error={formDataError?.test_auth_token} />
          </Wrapper>
          <Wrapper>
            <MessageHeading text="Ideabiz Merchant Details (LIVE)" />
            <MessageLabel text={"Live Consumer Key"} className="" />
            <AdminCustomInput id="ideabizLiveConsumerKey" type="text" name="live_consumer_key" value={formData?.live_consumer_key} onChange={handleInput} placeHolder={"Live Consumer Key"} ref={(el) => (combinedRef.current.live_consumer_key = el)} error={formDataError?.live_consumer_key} />
            <MessageLabel text={"Live Consumer Secret"} className="" />
            <AdminCustomInput id="ideabizLiveConsumerSecret" type="text" name="live_consumer_secret" value={formData?.live_consumer_secret} onChange={handleInput} placeHolder={"Live Consumer Secret"} ref={(el) => (combinedRef.current.live_consumer_secret = el)} error={formDataError?.live_consumer_secret} />
            <MessageLabel text={"Live Username"} className="" />
            <AdminCustomInput id="ideabizLiveUsername" type="text" name="live_username" value={formData?.live_username} onChange={handleInput} placeHolder={"Live Username"} ref={(el) => (combinedRef.current.live_username = el)} error={formDataError?.live_username} />
            <MessageLabel text={"Live Password"} className="" />
            <AdminCustomInput id="ideabizLivePassword" type="text" name="live_password" value={formData?.live_password} onChange={handleInput} placeHolder={"Live Password"} ref={(el) => (combinedRef.current.live_password = el)} error={formDataError?.live_password} />
            <MessageLabel text={"Live Auth Token"} className="" />
            <AdminCustomInput id="ideabizLiveAuthToken" type="text" name="live_auth_token" value={formData?.live_auth_token} onChange={handleInput} placeHolder={"Live Auth Token (Optional)"} ref={(el) => (combinedRef.current.live_auth_token = el)} error={formDataError?.live_auth_token} />
          </Wrapper>

        </RightWrapper>
        <AdminCustomButton id="bottomUpdateButton" className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={"Update Ideabiz"} loading={loading} />
      </FormContainer>
    </>
  );
}

export default Ideabiz;